import './sentrySetup';
import { environment } from '@core/environment';
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as THREE from 'three';
import { LicenseInfo } from '@mui/x-license';
import { App } from './App';
import './i18n.config';
import './index.css';

THREE.ColorManagement.enabled = false;

if (environment.useMockApi) {
  // if npm:with-mock-api script exits with error on start, try setting your VITE_ENABLE_PRODUCTION_PROFILING=false in your .env.development
  import('./core/api/__mocks__/browser');
}

LicenseInfo.setLicenseKey(environment.muiProLicenceKey);

const debug = false;

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find root element');
const root = createRoot(container);

root.render(
  debug ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  ),
);
